/**
 * Enum for the different types of empty states that can be displayed in
 * the `UiEmptyHazard` component.
 */
export enum EmptyStateType {
  HazardNotFound = 'HazardNotFound',
  HazardBuilding = 'HazardBuilding',
}
